import { IndicatorConfig, IndicatorFormat, IndicatorKey } from '../../tenants/types';
import { formatDate, parseFloatNumber } from './date-handlers';

/** Valores de indicadores del modelo común (claves `IndicatorKey`), tal como los arma cada página. */
export type IndicatorValues = Partial<Record<IndicatorKey, any>>;

const HECTARES_UNIT = 'Has';

/**
 * Formatea un indicador según su config. Reproduce exactamente el formateo previo de `ItemIndicators`
 * (`-` para valores vacíos, unidad `Has` en áreas) y de las páginas (`formatDate(v, false, true)` en fechas,
 * `parseFloatNumber(v, n)` para truncar áreas).
 */
export const formatIndicatorValue = (rawValue: any, config: IndicatorConfig): string => {
    switch (config.format) {
        case IndicatorFormat.Date: {
            const value = formatDate(rawValue, false, true);
            return value ? `${value}` : '-';
        }
        case IndicatorFormat.Hectares: {
            const value = config.decimals !== undefined ? parseFloatNumber(rawValue, config.decimals) : rawValue;
            return value ? `${value} ${HECTARES_UNIT}` : '-';
        }
        default:
            return rawValue ? `${rawValue}` : '-';
    }
};
